module.exports = __webpack_public_path__ + "static/icons/icon-heart-13263831f0b37c4e798d589535a4dde2.svg";